import {FC, useEffect} from "react";
import QRCode from "react-qr-code";
import Linda from "@images/team/linda.webp";
import Image from "next/image";
import {PageContactPropsBasicType} from "../../../@types/types-body";

const LindaCulba: FC<PageContactPropsBasicType> = ({
                                                       namespace,
                                                   }) => {
    const VcfQRCode = `BEGIN:VCARD
VERSION:3.0
N:Culba;Linda;;Bc.
FN:
ORG:Crowlyn\\, s.r.o.
X-MICROSOFT-OFFICELOC:Varšavská 715/36\\, 120 00 Praha
TITLE:CEO
TEL;TYPE=WORK,VOICE:+ 420 730 233 000
TEL;TYPE=CELL,VOICE:+ 420 730 233 000
EMAIL;TYPE=HOME,INTERNET:linda.culba@crowlyn.com
EMAIL;TYPE=WORK,INTERNET:info@crowlyn.com
URL;TYPE=WORK,Crowlyn:https://www.crowlyn.com
URL;TYPE=Facebook,Facebook:https://www.facebook.com/CrowlynCompany/
URL;TYPE=Twitter,Twitter:https://twitter.com/CrowlynCompany
URL;TYPE=Youtube,Youtube:https://www.youtube.com/channel/UCGNCzE32mjuYtGUn3mlPJ9g
URL;TYPE=Instagram,Instagram:https://www.instagram.com/crowlyncompany/
URL;TYPE=Linkedin,Linkedin:https://www.facebook.com/CrowlynCompany/
UID:
END:VCARD
`
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return (<div className="flex flex-col bg-crowlyn-night">
        <div
            className="grid grid-cols-1 lg:grid-cols-3 md:container mx-auto border-l-4 border-r-4 shadow-2xl drop-shadow-4xl shadow-gray-700">
            <section className="col-span-1 w-full bg-crowlyn-900 flex flex-col px-2 lg:px-8">
                <div className="mx-auto">
                    <Image src={Linda}
                           className="-px-2 lg:px-0 w-full h-auto shadow-2xl drop-shadow-4xl shadow-white rounded-xl"
                           alt="Bc. Linda Culba"/>
                </div>
                <h1 className="text-white text-4xl text-center mt-10 mb-10">Who Am I?</h1>
                <p className="text-white text-base mt-4">I am the CEO of Crowlyn company, in the role of IT project
                    manager with knowledge of web development and design. I am also experienced in content
                    writing.</p>
                <blockquote className="text-base italic font-semibold mt-8 text-center text-white">
                    &quot;Tailored Excellence in Every Byte&quot;
                </blockquote>
                <hr className="my-10 px-10"/>
                <h2 className="text-white text-3xl text-center">POWER PARTNERS:</h2>
                <ul className="text-white text-base mt-2 list-disc">
                    <li>Entrepreneurs starting a business</li>
                    <li>Companies starting a new project</li>
                    <li>Individuals with marketing needs</li>
                    <li>Clients looking for mobile app development</li>
                    <li>Projects
                        <ul className="text-gray-300 text-base mt-2 ml-4 list-decimal">
                            <li><a className={"text-gray-300 hover:text-white"} href={"https://linnykaycee.com/en"}>Life Stories - LinnyKayCee</a></li>
                            <li><a className={"text-gray-300 hover:text-white"} href={"https://cestouyogy.cz/en"}>Yoga Tips - CestouYogy</a></li>
                            <li><a className={"text-gray-300 hover:text-white"} href={"https://cestouyogy.cz/en"}>Fitness - ZenlyFit</a></li>
                            <li><a className={"text-gray-300 hover:text-white"} href={"https://energie-slov.cz/en"}>Writers - Energy of words project</a></li>
                        </ul>
                    </li>
                </ul>
                <hr className="my-10 px-10"/>
                <h3 className="text-white text-3xl text-center">NETWORKING:</h3>
                <ul className="text-white text-base mt-4 list-disc">
                    <li>Evolve (USA)</li>
                    <li>GROW (UK)</li>
                    <li>Leading ladies (CAN)</li>
                </ul>
                <div className="mx-auto text-white text-base mt-8 mb-20 ">
                </div>
            </section>
            <section className="col-span-1 w-full bg-white flex flex-col px-8">
                <div>
                    <h6 className="text-3xl text-center">Calendly:</h6>
                    <div className="calendly-inline-widget"
                         data-url="https://calendly.com/linda-culba/30min?hide_event_type_details=1&hide_gdpr_banner=1"
                         style={{minWidth: '100%', height: '700px'}}></div>
                </div>
                <blockquote className="text-2xl italic font-semibold text-gray-900 mt-8 text-center">Innovating
                    Tomorrow, Today: The Crowlyn Way
                </blockquote>
                <h5 className="text-3xl text-center mt-10 mb-5">ISSUES WE DEAL WITH:</h5>
                <ul className="text-base mt-4 mb-20 list-disc">
                    <li>Building a website or e-commerce, improving their existing websites</li>
                    <li>Creating unique mobile apps for individuals or companies</li>
                    <li>Helping clients with specific IT needs (Marketing consultation and Branding)</li>
                    <li>Technical consultations - technical or project quality review</li>
                    <li>Handling short-term and long-term maintenance for clients</li>
                </ul>
            </section>
            <section className="col-span-1 bg-white w-full flex border-l-4 flex-col px-2">
                <div className="mx-auto mt-10">
                    <h6 className="text-3xl text-center mb-8">Contact QR Code:</h6>
                    <div
                        className="md:p-4 md:border md:mx-auto md:border-black rounded-2xl">
                        <div
                            className="md:p-4 md:border md:mx-auto md:border-black h-full w-full md:rounded-2xl md:bg-gray-900 md:z-1">
                            <QRCode
                                size={256}
                                style={{height: "auto", maxWidth: "100%", width: "100%", background: "transparent"}}
                                value={VcfQRCode} viewBox={`0 0 256 256`}/>
                        </div>
                    </div>
                </div>
                <div className="my-20 px-8"><h3
                    className="font-normal text-2xl align-bottom mb-4 italic">Crowlyn, s.r.o.</h3>
                    <p id="paragraph-with-svg-icon-1" className="flex my-4 align-bottom"><span
                        className="w-4 h-4 fill-black mr-2 "><svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 384 512"><path
                        d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"></path></svg></span> Varšavská
                        715/36, Vinohrady, 120 00 Praha
                    </p>
                    <p id="paragraph-with-svg-icon-2" className="flex my-4 align-bottom"><span
                        className="w-4 h-4 fill-black mr-2 "><svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 512 512"><path
                        d="M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"></path></svg></span>linda.culba@crowlyn.com
                    </p>
                    <p id="paragraph-with-svg-icon-3" className="flex my-4 align-bottom"><span
                        className="w-4 h-4 fill-black mr-2 "><svg xmlns="http://www.w3.org/2000/svg"
                                                                  viewBox="0 0 512 512"><path
                        d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"></path></svg></span> +49
                        1512 3376347
                    </p>
                    <h6 className="text-3xl text-center">INTERESTS:</h6>
                    <ul className="text-base mt-4 list-disc">
                        <li>fitness and yoga</li>
                        <li>books and writing</li>
                        <li>movies, traveling, movies and international cuisine</li>
                    </ul>
                </div>

            </section>
        </div>
    </div>)
}
export default LindaCulba;